import React from "react";
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/CustomTable";
import { getAudiences } from "../../../store/actions/AudienceActions";

const Audience = () => {
  const navigate = useNavigate();

  const handleRowClick = (_id, row) => {
    if (!row?._id) return;
    const path =
      row.audience_type === "group" ? "/audience/edit-group" : "/audience/edit";
    navigate(path, { state: row });
  };

  const columns = [
    {
      label: "#",
      render: (row) => <span>{row.audienceCode ?? "-"}</span>,
    },
    {
      label: "Name",
      render: (row) => <span>{`${row.firstname} ${row.lastname}`}</span>,
    },
    {
      label: "Mobile",
      render: (row) => <span>{`${row.country_code}${row.mobile}`}</span>,
    },
    { label: "Email", key: "email" },
    {
      label: "City",
      render: (row) => <span>{`${row?.city?.name ?? "-"}`}</span>,
    },
    {
      label: "+Members",
      render: (row) => {
        if (row.guests && row.guests.length > 0) {
          return (
            <span>
              +{row.guests.length}{" "}
              {row.guests.length > 1 ? "Members" : "Member"}
            </span>
          );
        } else if (row.audience_type == 'group') {
          return <span>{row?.no_of_group_guest > 0 ? `+${row?.no_of_group_guest} ${row?.no_of_group_guest > 1 ? "Members" : "Member"}` : "-"}</span>;
        } else {
          return <span>-</span>;
        }
      },
    },
  ];

  const importData = () => {

  };

  return (
    <CustomTable
      columns={columns}
      title="Audience"
      getHook={getAudiences}
      store={"audience"}
      deleteHook={"audience"}
      addBtnTitle={"Add Audience"}
      secondBtnTitle={"Add Group"}
      search={true}
      importData={"upload-audiences"}
      onRowClick={handleRowClick}
    />
  );
};

export default Audience;
